import { IThunkContext } from '@cian/favorites-assign-widget/es/shared/types/redux';

import { ResponseError } from 'shared/errors/responseError';
import { IV2CheckPriceResponseSchema } from 'shared/repositories/dailyrent/entities/response/V2CheckPriceResponseSchema';
import {
  fetchCheckPrice as fetchCheckPriceHelper,
  TCheckPriceRequest,
  TCheckPriceResponse,
} from 'shared/repositories/dailyrent/v2/check-price';

const DEFAULT_ERROR_MESSAGE = 'Произошла ошибка при проверке доступности';

export const fetchCheckPrice = async (
  context: IThunkContext,
  parameters: TCheckPriceRequest,
): Promise<IV2CheckPriceResponseSchema> => {
  const { httpApi } = context;

  const data = (await fetchCheckPriceHelper({
    httpApi,
    parameters,
  })) as TCheckPriceResponse;

  if (data.statusCode === 400) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { key, code, message } = data.response.errors?.[0] || ({} as any);

    if (key && code && message) {
      throw new ResponseError({ domain: 'dailyrentBookingGeneral#checkPrice', message, details: { key, code } });
    }

    throw new ResponseError({ domain: 'dailyrentBookingGeneral#unknown', message: DEFAULT_ERROR_MESSAGE });
  }

  return data.response;
};
